
class Table {
  constructor($localStorage, uiGridConstants) {
    'ngInject';
    this.gridApi = null;
    this.uiGridConstants = uiGridConstants;
    this.store = $localStorage;
    this.activeFilters =  $localStorage.activeFilters ? $localStorage.activeFilters: {};
    this.activeSort =  $localStorage.activeSort ? $localStorage.activeSort : {};
  }

  // grid Api
  setGridApi(api) {
    this.gridApi = api;
  }

  notifyDataChange() {
    this.gridApi.core.notifyDataChange(this.uiGridConstants.dataChange.ALL);
  }

  // filter and sort states
  setActiveFilters(moduleName, filters) {
    this.store.activeFilters ? this.store.activeFilters[moduleName] = {
      ...this.store.activeFilters[moduleName],
      ...filters
    } : this.store.activeFilters = {
      [moduleName]: filters
    };

    this.activeFilters = this.store.activeFilters;
  }

  clearFilters(moduleName) {
    this.gridApi.grid.clearAllFilters();
    if (moduleName && this.store.activeFilters[moduleName]) {
      this.store.activeFilters[moduleName] = {};
    }
  }

  hasActiveFilters(moduleName) {
    if (this.store.activeFilters == undefined) return false;
    const activeFilters = this.store.activeFilters[moduleName];
    if (activeFilters == undefined) return false;
    return Object.values(activeFilters).length > 0;
  }


  mapActiveFilters(filter, options = {}) {
    let result = [];
    console.log('filter', filter);
    Object.keys(filter).forEach(key => {
      if (filter[key] == undefined) return;

      switch (key) {
        case 'custom_fields':
          filter[key].forEach(cf => {
            switch (cf.condition) {
              case 'range_between':
                if (cf.value_from && cf.value_to) {
                  result.push({ key: cf.custom_field_key, value: `from ${cf.value_from} to ${cf.value_to}`, title: cf.field });
                } else if (cf.value_from) {
                  result.push({ key: cf.custom_field_key, value: `from ${cf.value_from}`, title: cf.field });
                } else if (cf.value_to) {
                  result.push({ key: cf.custom_field_key, value: `to ${cf.value_to}`, title: cf.field });
                }
                break;
              case 'contains':
                result.push({ key: cf.custom_field_key, value: cf.contains.map( id => cf.available_options.find( e => (e.id == id) ).title ).join(', '), title: cf.field });
                break;
              case 'have':
                result.push({ key: cf.custom_field_key, value: cf.value, title: cf.field });
                break;
            }
          });
          break;
        case 'q':
          result.push({ key: 'q', value: filter[key], title: 'Search', column: 'default_record' });
          break;
        case 'search_by_location':
          result.push({ key: 'search_by_location', value: filter[key], title: 'Location', column: 'location' });
          break;
        case 'operation_type':
          result.push({ key: 'operation_type', value: filter[key], title: '', column: 'operation_type' });
          break;
        case 'area_min':
          if (filter['area_max']) {
            result.push({ key: 'area', value: `from ${filter['area_min']} to ${filter['area_max']}`, title: 'Area', column: 'area' });
          } else {
            result.push({ key: 'area_min', value: filter[key], title: 'Area min', column: 'area' });
          }
          break;
        case 'area_max':
          if (!filter['area_min']) {
            result.push({ key: 'area_max', value: filter[key], title: 'Area max', column: 'area' });
          }
          break;
        case 'price_min':
          if (filter['price_max']) {
            result.push({ key: 'price', value: `from ${filter['price_min']} to ${filter['price_max']}`, title: 'Price', column: 'price' });
          } else {
            result.push({ key: 'price_min', value: filter[key], title: 'Price min', column: 'price' });
          }
          break;
        case 'price_max':
          if (!filter['price_min']) {
            result.push({ key: 'price_max', value: filter[key], title: 'Price max', column: 'price' });
          }
          break;
        case 'updated_at_from':
          if (filter['updated_at_to']) {
            result.push({ key: 'updated_at', value: `from ${filter['updated_at_from']} to ${filter['updated_at_to']}`, title: 'Updated at', column: 'updated_at' });
          } else {
            result.push({ key: 'updated_at_from', value: filter[key], title: 'Updated at from', column: 'updated_at' });
          }
          break;
        case 'updated_at_to':
          if (!filter['updated_at_from']) {
            result.push({ key: 'updated_at_to', value: filter[key], title: 'Updated at to', column: 'updated_at' });
          }
          break;
        case 'created_at_from':
          if (filter['created_at_to']) {
            result.push({ key: 'created_at', value: `from ${filter['created_at_from']} to ${filter['created_at_to']}`, title: 'Created at', column: 'created_at' });
          } else {
            result.push({ key: 'created_at_from', value: filter[key], title: 'Created at from', column: 'created_at' });
          }
          break;
        case 'created_at_to':
          if (!filter['created_at_from']) {
            result.push({ key: 'created_at_to', value: filter[key], title: 'Created at to', column: 'created_at' });
          }
          break;

        case 'user_id':
          if (options.users == undefined) return;
          result.push({ key: 'user_id', value: options.users[filter[key]], title: '', column: 'user_id' });
          break;

        case 'estate_type_id':
          if (!filter[key].length) return;
          result.push({
            column: 'estate_type_id',
            key: 'estate_type_id', value: (
              filter[key].map(id => options.estateTypes[id]).join(', ')
            ), title: '' });
          break;

        case 'search_by_phone':
          result.push({ key: 'search_by_phone', value: filter[key], title: 'Phone', column: 'phone' });
          break;

        case 'search_by_email':
          result.push({ key: 'search_by_email', value: filter[key], title: 'Email', column: 'email' });
          break;
      }
    });
    return result;
  }

  setActiveSort(moduleName, sort) {
    this.store.activeSort ? this.store.activeSort[moduleName] = {
      ...sort
    } : this.store.activeSort = {
      [moduleName]: sort
    };

    this.activeSort = this.store.activeSort;
  }
}
export default Table;
